import React from 'react';
import {
  Box,
  Divider,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import Image from 'next/image';

const texts = Object.freeze({
  headline: 'Personalized recommendations.',
  subHeadline: 'Objective ratings.',
  description: `The Nerds have combed through countless credit cards to provide
objective ratings along with your personalized recommendations to
help you choose a great card for your needs.`,
});

export const PersonalizedRecommendationsSection = () => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('xl'));

  return (
    <Box
      paddingY={{ xs: 0, xl: 11 }}
      paddingBottom={{ xs: 8, xl: 8 }}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      margin="0 auto"
      width={{ xs: '82%', xl: '68%' }}
      gap={3}
    >
      <Divider
        sx={{
          height: '2px',
          width: { xs: '30%', xl: '100%' },
          margin: '0 auto',
          backgroundColor: 'neutral.lighter',
        }}
      />
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent={{ xs: 'center', xl: 'space-between' }}
        gap={3.5}
        margin="0 auto"
        flexWrap={{ xs: 'wrap-reverse', xl: 'nowrap' }}
        width="100%"
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
          justifyContent="center"
          gap={2.25}
          maxWidth={{ xs: '500px', xl: '500px' }}
        >
          <Box
            display="flex"
            flexDirection="column"
            alignItems={{ xs: 'center', xl: 'flex-start' }}
            textAlign={{ xs: 'center', xl: 'left' }}
            justifyContent="center"
            gap={1}
            width="100%"
          >
            <Typography variant="bodyLargeBold">{texts.headline}</Typography>
            <Typography variant="bodyLargeBold">{texts.subHeadline}</Typography>
          </Box>
          <Typography maxWidth={{ xs: '410px', xl: 'unset' }}>
            {texts.description}
          </Typography>
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          maxWidth={620}
        >
          <Image
            src="https://www.nerdwallet.com/cdn/cardfinder/personalized-recommendations.webp"
            alt=""
            style={{
              width: matches ? '100%' : '150%',
              height: 'auto',
              maxWidth: '100vw',
            }}
            width={0}
            height={0}
            sizes="100vw"
            unoptimized
          />
        </Box>
      </Box>
    </Box>
  );
};
